<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pr-4 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top">
        <div class="col">
          <div>
            <h4>
              <svg
                width="24"
                height="24"
                fill="currentColor"
                class="bi-file-earmark me-2 b-icon bi"
                viewBox="0 0 16 16"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                  id="path2"
                />
                <path
                  d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
                  id="path2-4"
                />
              </svg>
              Abrechnung
            </h4>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <!-- SEARCH FIELD  -->
            <b-input-group class="ml-2 header-search-field">
              <b-form-input
                type="search"
                size="sm"
                v-model.lazy="searchText"
                :class="{ 'bg-primary-light-3': searchText !== '' }"
                placeholder="Suchenbegriff eingeben..."
                @update="onSearchTextChanged"
              ></b-form-input>
              <template #prepend>
                <b-input-group-text>
                  <b-icon variant="dark" icon="search" />
                </b-input-group-text>
              </template>
            </b-input-group>
            <!-- FILTER BUTTON  :disabled="!isDeleteButtonEnabled"-->
            <b-button
              size="sm"
              :variant="filterToggle == true ? 'primary' : 'light'"
              class="ml-2"
              :pressed="filterToggle"
              @click="filterRecords"
              :disabled="selectedRows.length == 0 && !filterToggle"
            >
              <b-icon icon="funnel"></b-icon>
            </b-button>
            <!-- COPY TO EXCEL  -->
            <b-button
              size="sm"
              variant="light"
              class="ml-2"
              @click="copyToExcel"
              title="In Zwischenablage für Excel kopieren"
            >
              <!-- Custom copy-to-spreadsheet icon: back sheet (copy) + front sheet with table grid -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                aria-hidden="true"
                style="vertical-align: -0.125em"
              >
                <path
                  d="M6 0a1.5 1.5 0 0 0-1.5 1.5V3H6V1.5a.5.5 0 0 1 .5-.5h4v2A1.5 1.5 0 0 0 12 4.5h2v6a.5.5 0 0 1-.5.5H12v1h1.5A1.5 1.5 0 0 0 15 10.5V3.914a1.5 1.5 0 0 0-.44-1.06L12.147.439A1.5 1.5 0 0 0 11.086 0H6zm5.5 1.207L13.293 3H12a.5.5 0 0 1-.5-.5V1.207z"
                />
                <path
                  d="M1.5 5A1.5 1.5 0 0 0 0 6.5v8A1.5 1.5 0 0 0 1.5 16h7A1.5 1.5 0 0 0 10 14.5v-8A1.5 1.5 0 0 0 8.5 5h-7zM1 6.5a.5.5 0 0 1 .5-.5H4v2.25H1V6.5zm4-.5h3.5a.5.5 0 0 1 .5.5v1.75H5V6zM1 9.25h3v2.5H1v-2.5zm4 0h4v2.5H5v-2.5zM1 12.5h3V15H1.5a.5.5 0 0 1-.5-.5v-2zm4 0h4v2a.5.5 0 0 1-.5.5H5v-2.5z"
                />
              </svg>
            </b-button>
            <!-- HELP ICON  -->
            <b-button size="sm" variant="light" class="ml-2" href="https://www.bauvisor.de/abrechnung/" target="_blank">
              <b-icon icon="question-circle" variant="dark" class=""></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="main-canvas">
      <div class="shadow-muted-super" ref="budgetSummarySection">
        <table class="w-100 bg-white">
          <tr class="border">
            <td class="px-2 py-1" colspan="8" v-b-toggle.collapse-invoices>
              <small>Übersicht - Aktuelle Abrechnung</small>
            </td>
            <td class="text-right pr-2">
              <b-button v-b-toggle.collapse-invoices variant="white" size="sm">
                <span class="when-opened">
                  <b-icon icon="chevron-up" class="action-button" />
                </span>
                <span class="when-closed"><b-icon icon="chevron-down" class="action-button" /></span>
              </b-button>
            </td>
          </tr>
        </table>

        <b-collapse id="collapse-invoices" :visible="isTabOpen" @shown="onWindowResize" @hidden="onWindowResize">
          <b-overlay :show="isHeaderLoading" rounded="sm" spinner-variant="primary" opacity="0.8">
            <table class="w-100 bg-white">
              <tr class="border border-top-0 border-bottom-0">
                <td class="p-2 font-weight-bold small border-bottom">VE-Budget</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudget, SettingsStore) }}
                  </div>
                </td>
                <td class="border-bottom">&nbsp;</td>
              </tr>
              <tr>
                <td class="p-2 pl-4 font-weight-bold border-left small">Entfallende Leistungen</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVESkipped, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right border-bottom text-right pr-2 small">
                  <small>{{ $utils.numberWithMaxFrictionsDE((budgetVESkipped / budgetVEBudget) * 100, 1) }}%</small>
                </td>
                <td colspan="6" class="border-right">&nbsp;</td>
              </tr>
              <tr>
                <td class="p-2 pl-4 font-weight-bold border-left border-top border-bottom small">Offenes Budget</td>
                <td class="font-weight-bold border-bottom text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetVEBudgetOpen + this.budgetVEBudgetAusgeschrieben + this.budgetVEBudgetAusgewertet,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="border-right border-bottom text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((this.budgetVEBudgetOpen +
                          this.budgetVEBudgetAusgeschrieben +
                          this.budgetVEBudgetAusgewertet) /
                          budgetVEBudget) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td colspan="6" class="border-bottom border-right">&nbsp;</td>
              </tr>

              <tr>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold border-left small">Beauftragtes Budget</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced, SettingsStore)
                    }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced) / budgetVEBudget) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold small">Gesamtaufträge</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountSaldo, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (this.budgetOrderAmountSaldo / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pt-2 pb-1 pl-4 font-weight-bold small">Leistung abgerechnet</td>
                <td class="font-weight-bold text-right small">
                  <div class="bg-light m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (this.budgetOrderAmountLeistungInvoiced / this.budgetOrderAmountSaldo) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>

              <tr>
                <td class="p-0 pl-5 border-left small">in Arbeit befindlich</td>
                <td class="p-0 text-right small">
                  <div class="m-0 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudgetInArbeit, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetVEBudgetInArbeit / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">in Arbeit befindlich</td>
                <td class="p-0 text-right small">
                  <div class="m-0 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountInArbeit, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE((budgetOrderAmountInArbeit / budgetOrderAmountSaldo) * 100, 1)
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">teilabgerechnet</td>
                <td class="p-0 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoicedPartly, SettingsStore) }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetOrderAmountLeistungInvoicedPartly / budgetOrderAmountInArbeit) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 border-left small">&nbsp;</td>
                <td class="p-0 small">&nbsp;</td>
                <td class="p-0 border-right text-right small">&nbsp;</td>
                <td class="p-0 small"></td>
                <td class="p-0 small"></td>
                <td class="p-0 border-right text-right pr-2 small">&nbsp;</td>
                <td class="p-0 pl-5 small">Obligo</td>
                <td class="p-0 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetOrderAmountInArbeit - this.budgetOrderAmountLeistungInvoicedPartly,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="p-0 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((budgetOrderAmountInArbeit - budgetOrderAmountLeistungInvoicedPartly) /
                          budgetOrderAmountInArbeit) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 border-left small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetVEBudgetInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetVEBudgetInvoiced / (this.budgetVEBudgetInArbeit + this.budgetVEBudgetInvoiced)) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountInvoiced, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE((budgetOrderAmountInvoiced / budgetOrderAmountSaldo) * 100, 1)
                    }}%
                  </small>
                </td>
                <td class="p-0 pl-5 small">schlussgerechnet</td>
                <td class="text-right small">
                  <div class="m-0 py-1 px-2">
                    {{ $utils.formatCurrency(this.budgetOrderAmountLeistungInvoicedFinal, SettingsStore) }}
                  </div>
                </td>
                <td class="border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        (budgetOrderAmountLeistungInvoicedFinal / budgetVEBudgetInvoiced) * 100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
              <tr>
                <td class="p-0 pl-5 pb-2 border-left small">&nbsp;</td>
                <td class="p-0 pb-2 small">&nbsp;</td>
                <td class="p-0 pb-2 border-right text-right small">&nbsp;</td>
                <td class="p-0 pb-2 small"></td>
                <td class="p-0 pb-2 small"></td>
                <td class="p-0 pb-2 border-right text-right pr-2 small">&nbsp;</td>
                <td class="p-0 pb-2 pl-5 small">Budgetunterschreitung</td>
                <td class="p-0 pb-2 text-right small">
                  <div class="m-0 py-1 px-2">
                    {{
                      $utils.formatCurrency(
                        this.budgetVEBudgetInvoiced - this.budgetOrderAmountLeistungInvoicedFinal,
                        SettingsStore
                      )
                    }}
                  </div>
                </td>
                <td class="p-0 pb-2 border-right text-right pr-2 small">
                  <small>
                    {{
                      $utils.numberWithMaxFrictionsDE(
                        ((budgetVEBudgetInvoiced - budgetOrderAmountLeistungInvoicedFinal) / budgetVEBudgetInvoiced) *
                          100,
                        1
                      )
                    }}%
                  </small>
                </td>
              </tr>
            </table>
          </b-overlay>
        </b-collapse>
      </div>

      <b-nav
        tabs
        class="mt-3 pl-2"
        v-if="!$route.path.endsWith('/create')"
        style="margin-left: -25px; margin-right: -25px"
      >
        <b-nav-item
          to="/invoices"
          v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
          style="padding-left: 16px"
        >
          Vergabeeinheiten
        </b-nav-item>
        <b-nav-item
          to="/invoices/all"
          v-if="$route.name !== 'Chancen & Risiken Details' && $route.name !== 'Chancen & Risiken Formular'"
        >
          Belege
        </b-nav-item>
      </b-nav>

      <div class="table-wrapper table-fill shadow-muted-super mt-3" :style="{ height: tableHeight }" ref="tableWrapper">
        <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.8" z-index="1100">
          <b-table
            ref="theTable"
            v-resizable-columns="{ fields: visibleFields, storageKey: 'invoices', flexLast: false, minWidth: 0 }"
            :items="filteredItems"
            :fields="visibleFields"
            class="bg-white shadow-muted-super sum-header mb-0"
            head-variant="light"
            no-border-collapse
            small
            :sticky-header="tableHeight"
            show-empty
            hover
          >
            <template #head(checked)>
              <b-form-checkbox
                class="ml-2"
                :disabled="items.length == 0"
                v-model="checkedAllTableEntries"
                @change="onCheckAllTableEntries"
              ></b-form-checkbox>
            </template>
            <template #head(BudgetSaldo)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey text-nowrap"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(budgetSaldoTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(Amount)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(amountTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(AmountAddendumOrdered)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(nachtragSummeTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(AmountSaldo)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(totalAmountTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(Invoiced)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(invoicedTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(ObligoAmount)="data">
              <div style="padding-right: 2px">
                {{ data.label }}
              </div>
              <div
                class="font-weight-bold text-right text-grey"
                :class="{ 'text-primary': searchText != '' || filterToggle }"
              >
                <b-icon icon="funnel-fill" v-if="searchText != '' || filterToggle" />
                {{ $utils.formatCurrency(obligoTotal, SettingsStore) }}
              </div>
            </template>
            <template #head(actions)="data">
              {{ data.label }}

              <span @click="$bvModal.show('invoices')" role="button">
                <b-icon icon="three-dots-vertical" class="float-right no-outline" style="margin-top: 4px" />
              </span>
            </template>
            <template #cell(actions)="data">
              <b-icon
                class="action-button text-grey"
                style="width: 18px; height: 18px"
                icon="arrow-right"
                title="Letzen Beleg öffnen"
                @click.stop="navigateTo(data.item, true)"
                v-if="data.item.MaxDbId != null"
              />
              <b-icon
                variant="grey"
                style="width: 18px; height: 18px; cursor: not-allowed; color: #ddd"
                icon="arrow-right"
                title="Keine Belege vorhanden"
                v-if="data.item.MaxDbId == null"
                @click.stop="items.find(x => x.Index > data.item.Index)"
              />
              <b-icon
                class="action-button text-grey ml-2"
                style="width: 18px; height: 18px"
                icon="file-earmark"
                title="Auftrag öffnen"
                @click.stop="openOrder(data.item)"
              />
              <b-icon
                class="action-button text-grey ml-2"
                style="width: 18px; height: 18px"
                icon="card-list"
                title="Belege"
                @click.stop="navigateTo(data.item)"
              />
              <!--
              <b-icon
                icon="trash"
                variant="grey"
                class="action-button ml-2"
                style="width: 16px; height: 16px"
                title="Löschen"
                @click.stop="deleteRecord(data.item)" /> -->
            </template>
            <template #cell(checked)="data">
              <b-form-checkbox
                class="ml-2"
                @change="onRowChecked(data.item)"
                v-model="data.item.checked"
                :disabled="data.item.editMode"
              ></b-form-checkbox>
            </template>
            <template #cell(Ordinal)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.Ordinal }}</div>
            </template>
            <template #cell(DisplayName)="data">
              <div @click.stop="navigateTo(data.item)">
                {{ data.item.DisplayName }}
              </div>
            </template>
            <template #cell(BudgetSaldo)="data">
              <div @click.stop="$router.push('/allocationunits/' + data.item.VeDbId)">
                {{ $utils.formatCurrency(data.item.BudgetSaldo, SettingsStore) }}
              </div>
            </template>
            <template #cell(ProcessStatus)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.ProcessStatus }}</div>
            </template>
            <template #cell(KGR)="data">
              <div @click.stop="navigateTo(data.item)" v-ellipsis-title>{{ data.item.KGR || '&nbsp;' }}</div>
            </template>
            <template #cell(Responsible)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.Responsible || '&nbsp;' }}</div>
            </template>
            <template #cell(FA1)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.FA1 || '&nbsp;' }}</div>
            </template>
            <template #cell(FA2)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.FA2 || '&nbsp;' }}</div>
            </template>
            <template #cell(SupplierText)="data">
              <div @click.stop="navigateTo(data.item)">{{ data.item.SupplierText }}</div>
            </template>
            <template #cell(OrderStatus)="data">
              <div @click.stop="$router.push('/orders/' + data.item.DbId)">{{ data.value }}</div>
            </template>
            <template #cell(Amount)="data">
              <div @click.stop="$router.push('/orders/' + data.item.DbId)">
                {{ $utils.formatCurrency(data.item.Amount, SettingsStore) }}
              </div>
            </template>
            <template #cell(AmountAddendumOrdered)="data">
              <div @click.stop="$router.push('/orders/' + data.item.DbId + '/addendums')">
                {{ $utils.formatCurrency(data.item.AmountAddendumOrdered, SettingsStore) }}
              </div>
            </template>
            <!--
            <template #cell(TotalAmount)="data">
              <div @click.stop="$router.push('/orders/' + data.item.DbId + '/addendums')">
                {{
                  $utils.formatCurrency(
                    parseFloat(data.item.Amount) + parseFloat(data.item.AmountAddendumOrdered),
                    SettingsStore
                  )
                }}
              </div>
            </template>-->
            <template #cell(AmountSaldo)="data">
              <div @click.stop="$router.push('/orders/' + data.item.DbId + '/addendums')">
                {{ $utils.formatCurrency(data.item.AmountSaldo, SettingsStore) }}
              </div>
            </template>
            <template #cell(Invoiced)="data">
              <div @click.stop="$router.push('/invoices/' + data.item.DbId)">
                {{ $utils.formatCurrency(data.item.Invoiced, SettingsStore) }}
              </div>
            </template>
            <template #cell(InvoicedPercent)="data">
              <div @click.stop="$router.push('/invoices/' + data.item.DbId)">
                {{
                  $utils.numberWithMaxFrictionsDE(
                    (parseFloat(data.item.Invoiced) /
                      (parseFloat(data.item.Amount) + parseFloat(data.item.AmountAddendumOrdered))) *
                      100,
                    1
                  )
                }}
                <!-- {{ parseFloat(data.item.Invoiced) / (parseFloat(data.item.Amount) + parseFloat(data.item.AmountAddendumOrdered)) }} -->
              </div>
            </template>
            <template #cell(ObligoAmount)="data">
              <div @click.stop="$router.push('/invoices/' + data.item.DbId)">
                {{ $utils.formatCurrency(data.item.ObligoAmount, SettingsStore) }}
              </div>
            </template>
            <template #cell(HasFinalInvoice)="data">
              <!-- schlussgerechnet UND geprüft -->
              <b-badge
                pill
                class="sr-kennzeichen"
                v-if="data.item.HasFinalInvoice > 0 && data.item.FinalAmountStatus == 2"
                variant="info"
                style="font-size: 100%"
                title="schlussgerechnet, geprüft"
              >
                <b-icon class="p-0" icon="check-2" />
              </b-badge>
              <!-- schlussgerechnet, aber nicht geprüft -->
              <b-badge
                pill
                class="sr-kennzeichen light"
                v-if="data.item.HasFinalInvoice > 0 && data.item.FinalAmountStatus != 2"
                variant="info"
                style="font-size: 100%"
                title="schlussgerechnet, ungeprüft"
              >
                <b-icon class="p-0" icon="check-2" />
              </b-badge>
            </template>
          </b-table>
        </b-overlay>
        <TableFooter
          :displayed-count="displayedItemsCount"
          :selected-count="selectedRows.length"
          :loading="isLoading"
        />
      </div>
    </div>
    <TableColumnSelector
      :fields="fields"
      id="invoices"
      @ok="AppState.updateVisibleFields('invoices', fields)"
    ></TableColumnSelector>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import OrdersService from '@/service/OrdersService.js';
import SettingsStore from '@/store/Settings';
import BudgetService from '@/service/BudgetService';
import TableColumnSelector from '@/components/TableColumnSelector';
import TableFooter from '@/components/TableFooter';
import { copyTableToClipboard } from '@/utils/tableExport';

export default {
  components: {
    TableColumnSelector,
    TableFooter
  },

  data() {
    return {
      AppState,
      filterToggle: false,
      selectedRows: [],
      displayedItemsCount: 0,
      SettingsStore,
      isLoading: true,
      isHeaderLoading: true,
      checkedAllTableEntries: false,
      tableHeight: '500px',
      //emptyBoxWidth: 0,
      items: [],
      filteredItems: [],
      budgetKKE: 0.0,
      budgetPAT: 0.0,
      budgetVEBudget: 0.0,
      budgetVESkipped: 0.0,
      budgetVEBudgetOpen: 0.0,
      budgetVEBudgetInvoiced: 0.0,
      budgetVEBudgetAusgeschrieben: 0.0,
      budgetVEBudgetAusgewertet: 0.0,
      budgetVEBudgetInArbeit: 0.0,
      budgetOrderAmountSaldo: 0.0,
      budgetOrderAmountInvoiced: 0.0,
      budgetOrderAmountInArbeit: 0.0,
      budgetOrderAmountLeistungInvoiced: 0.0,
      budgetOrderAmountLeistungInvoicedFinal: 0.0,
      budgetOrderAmountLeistungInvoicedPartly: 0.0,
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 1002;width: 40px;',
          tdStyle: 'z-index: 9;'
        },
        {
          hideable: false,
          visible: true,
          key: 'Ordinal',
          label: 'VE',
          thClass: 'align-top sticky-col second-col',
          tdClass: 'sticky-col second-col',
          sortable: true,
          thStyle: 'z-index: 1002;width: 140px;',
          tdStyle: 'z-index: 9;'
        },
        {
          visible: true,
          hideable: false,
          key: 'DisplayName',
          label: 'Bezeichnung',
          thClass: 'align-top sticky-col third-col',
          tdClass: 'sticky-col third-col',
          sortable: true,
          thStyle: 'z-index: 1002;width: 300px;',
          tdStyle: 'z-index: 9;'
        },
        {
          hideable: SettingsStore.settings['KGR_Selections_Active'] == 'true',
          visible: SettingsStore.settings['KGR_Selections_Active'] == 'true',
          key: 'KGR',
          label: 'Kostengruppe',
          sortable: true,
          tdClass: 'bg-white',
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'Responsible',
          label: 'Verantwortlich',
          sortable: true,
          thClass: 'align-top',
          tdClass: 'bg-white'
        },
        {
          hideable: true,
          visible: true,
          key: 'FA1',
          label: SettingsStore.settings['FA1'],
          sortable: true,
          thClass: 'align-top',
          tdClass: 'bg-white'
        },
        {
          hideable: true,
          visible: true,
          key: 'FA2',
          label: SettingsStore.settings['FA2'],
          sortable: true,
          thClass: 'align-top',
          tdClass: 'bg-white'
        },
        {
          hideable: true,
          visible: true,
          key: 'ProcessStatus',
          label: 'Status',
          tdClass: 'bg-white',
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'SupplierText',
          label: 'Auftragnehmer',
          tdClass: 'bg-white',
          sortable: true,
          thClass: 'align-top'
        },
        {
          hideable: true,
          visible: true,
          key: 'OrderStatus',
          label: 'Auftragsstatus / Datum',
          tdClass: 'bg-white',
          sortable: true,
          thClass: 'align-top',
          formatter: (value, key, item) => {
            if (item.veSection && item.veSection == 'A') {
              return (
                (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
                ' / ' +
                this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
              );
            } else if (item.veSection && item.veSection == 'B') {
              return (
                (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
                ' / ' +
                this.$utils.SQLDateToGermanDate(item.OrderDate)
              );
            } else return '';
          },
          sortByFormatted: true
        },
        {
          hideable: true,
          visible: true,
          key: 'BudgetSaldo',
          label: 'Budget',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'text-right bg-primary-light-semi',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'Amount',
          label: 'Hauptauftrag',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          tdClass: 'text-right bg-primary-light-2',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountAddendumOrdered',
          label: 'Nachträge',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          tdClass: 'bg-primary-light-2 text-right',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountSaldo',
          label: 'Gesamtauftrag',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          tdClass: 'bg-primary-light-2 text-right',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'Invoiced',
          label: 'Abgerechnet',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'bg-primary-light-3 text-right',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'InvoicedPercent',
          label: '%',
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'bg-primary-light-3 text-right'
        },
        {
          hideable: true,
          visible: true,
          key: 'ObligoAmount',
          label: 'Obligo',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore),
          sortable: true,
          thClass: 'align-top text-right',
          tdClass: 'bg-primary-light-3 text-right',
          thStyle: 'padding-right: 12px;'
        },
        {
          hideable: true,
          visible: true,
          key: 'HasFinalInvoice',
          label: 'SR',
          sortable: true,
          thClass: 'align-top',
          tdClass: 'bg-white text-center',
          formatter: x => (Number(x) > 0 ? 'Ja' : 'Nein')
        },
        {
          hideable: true,
          visible: true,
          key: 'AbnahmeDatum',
          label: 'Abnahme',
          formatter: x => this.$utils.SQLDateToGermanDate(x),
          sortable: true,
          thClass: 'align-top',
          tdClass: 'bg-white'
        },
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 1002;',
          tdStyle: 'z-index: 9;'
        }
      ],
      budgetSaldoTotal: 0,
      amountTotal: 0,
      nachtragSummeTotal: 0,
      totalAmountTotal: 0,
      invoicedTotal: 0,
      obligoTotal: 0,
      searchText: ''
    };
  },
  methods: {
    async copyToExcel() {
      // Export the currently displayed rows in table order (search filter and sorting applied).
      const table = this.$refs.theTable;
      const items = (table && (table.computedItems || table.sortedItems)) || this.filteredItems;
      try {
        await copyTableToClipboard(this.visibleFields, items);
        this.$showSuccess(
          this,
          'Excel-Export',
          items.length + ' Zeile(n) in die Zwischenablage kopiert.',
          'b-toaster-top-center'
        );
      } catch (error) {
        this.$showError(this, error.toString());
      }
    },
    recalcSums(items) {
      this.budgetSaldoTotal = 0;
      this.amountTotal = 0;
      this.nachtragSummeTotal = 0;
      this.totalAmountTotal = 0;
      this.invoicedTotal = 0;
      this.obligoTotal = 0;
      items.map(x => {
        this.budgetSaldoTotal += parseFloat(x.BudgetSaldo);
        this.amountTotal += parseFloat(x.Amount);
        this.nachtragSummeTotal += parseFloat(x.AmountAddendumOrdered);
        this.totalAmountTotal += parseFloat(x.AmountSaldo);
        this.invoicedTotal += parseFloat(x.Invoiced);
        if (x.HasFinalInvoice != 0 && x.FinalAmountChecked != 0) {
          x.ObligoAmount = 0;
        } else {
          x.ObligoAmount = parseFloat(x.Amount) + parseFloat(x.AmountAddendumOrdered) - parseFloat(x.Invoiced);
          this.obligoTotal += x.ObligoAmount;
        }

        //x.checked = false;
        return x;
      });
    },
    navigateTo(item, toTheLast = false) {
      //if (item.editMode) return; // cancel navigation, if item is in edit mode
      if (toTheLast) {
        this.$router.push('/invoices/' + item.DbId + '/' + item.MaxDbId);
      } else {
        this.$router.push('/invoices/' + item.DbId);
      }
    },
    openOrder(item) {
      this.$router.push('/orders/' + item.DbId + '/view');
    },
    onSearchTextChanged() {
      // if search text is cleared, reset filtered items to all items
      if (this.searchText == '') {
        this.filteredItems = this.items; // all items
        this.onRowChecked(); // re-apply checked status to checkboxes, since onRowChecked also unchecks checkboxes that are filtered out, to prevent "ghost" checked checkboxes when search text is changed
        return;
      }
      // filter items based on search text, but prevent checked checkboxes from being lost
      this.filteredItems = this.filteredItems.filter(item => {
        if (item.DisplayName.toLowerCase().includes(this.searchText.toLowerCase())) {
          return item;
        } else {
          item.checked = false; // uncheck items that are filtered out, to prevent "ghost" checked checkboxes when search text is changed
          return false;
        }
      });
      this.onRowChecked();
      this.recalcSums(this.filteredItems);
    },
    onCheckAllTableEntries() {
      this.filteredItems = this.filteredItems.map(item => {
        item.checked = this.checkedAllTableEntries;
        return item;
      });
      this.onRowChecked();
    },
    onRowChecked() {
      this.selectedRows = this.filteredItems.filter(x => x.checked);
      this.checkedAllTableEntries = this.selectedRows.length == this.filteredItems.length;
    },
    onWindowResize() {
      setTimeout(() => {
        const totalHeight = window.innerHeight;
        const budgetSummarySection = this.$refs.budgetSummarySection;
        //const headerHeight = this.$refs.pageHeader.offsetHeight;
        const tableHeight = totalHeight - budgetSummarySection.offsetHeight - 185;
        this.tableHeight = tableHeight + 'px';
        //this.emptyBoxWidth = this.$refs.tableWrapper ? this.$refs.tableWrapper.clientWidth : 0;
      }, 300);
    },
    filterRecords() {
      if (!this.filterToggle) {
        // filter activated, show only selected rows - remember current state of items in case filter is deactivated again
        this.filterToggle = true;
        this.checkedAllTableEntries = true;
        this.itemsBackup = [...this.items];
        this.filteredItems = this.selectedRows;
      } else {
        this.filteredItems = this.itemsBackup;
        this.filterToggle = false;
        this.checkedAllTableEntries = this.filteredItems.reduce((acc, item) => acc && item.checked, true);
      }
      this.displayedItemsCount = this.filteredItems.length;
      this.recalcSums(this.filteredItems);
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    },
    isTabOpen() {
      return localStorage.getItem('collapse-invoices') == 'true' ? true : false;
    }
  },
  created() {
    this.$eventBus.$on('projectSwitched', () => {
      this.searchText = '';
    });
  },
  activated() {
    AppState.loadVisibleFields('invoices', this.fields);
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls

    this.fields.find(x => x.key == 'KGR').hideable = SettingsStore.settings['KGR_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'Responsible').hideable =
      SettingsStore.settings['Responsible_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'FA1').hideable = SettingsStore.settings['FA1_Active'] == 'true';
    this.fields.find(x => x.key == 'FA2').hideable = SettingsStore.settings['FA2_Active'] == 'true';

    this.fields.find(x => x.key == 'KGR').visible =
      this.fields.find(x => x.key == 'KGR').visible && SettingsStore.settings['KGR_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'Responsible').visible =
      this.fields.find(x => x.key == 'Responsible').visible &&
      SettingsStore.settings['Responsible_Selections_Active'] == 'true';
    this.fields.find(x => x.key == 'FA1').visible =
      this.fields.find(x => x.key == 'FA1').visible && SettingsStore.settings['FA1_Active'] == 'true';
    this.fields.find(x => x.key == 'FA2').visible =
      this.fields.find(x => x.key == 'FA2').visible && SettingsStore.settings['FA2_Active'] == 'true';

    this.fields.find(x => x.key == 'FA1').label = SettingsStore.settings['FA1'];
    this.fields.find(x => x.key == 'FA2').label = SettingsStore.settings['FA2'];

    this.isLoading = true;
    this.isHeaderLoading = true;
    AppState.isLoading = false;

    BudgetService.getSummary()
      .then(summary => {
        this.budgetKKE = summary.KkeBudgetSummary;
        this.budgetPAT = summary.PatBudgetSummary;

        this.budgetVESkipped = summary.VEBudgetSkipped;
        this.budgetVEBudgetOpen = summary.VEBudgetOpen;
        this.budgetVEBudgetInvoiced = summary.VEBudgetInvoiced;
        this.budgetVEBudgetAusgeschrieben = summary.VEBudgetAusgeschrieben;
        this.budgetVEBudgetAusgewertet = summary.VEBudgetAusgewertet;
        this.budgetVEBudgetInArbeit = summary.VEBudgetInArbeit;
        this.budgetOrderAmountSaldo = summary.OrderAmountSaldo;
        this.budgetOrderAmountInvoiced = summary.OrderAmountInvoiced;
        this.budgetOrderAmountInArbeit = summary.OrderAmountInArbeit;
        this.budgetOrderAmountLeistungInvoiced = summary.OrderAmountLeistungInvoiced;
        this.budgetOrderAmountLeistungInvoicedFinal = summary.OrderAmountLeistungInvoicedFinal;
        this.budgetOrderAmountLeistungInvoicedPartly = summary.OrderAmountLeistungInvoicedPartly;
        // ----------
        this.budgetVEBudget =
          this.budgetVESkipped +
          this.budgetVEBudgetOpen +
          this.budgetVEBudgetAusgeschrieben +
          this.budgetVEBudgetAusgewertet +
          this.budgetVEBudgetInArbeit +
          this.budgetVEBudgetInvoiced;
      })
      .catch(err => console.log(err.toString()))
      .finally(() => {
        this.isHeaderLoading = false;
      });

    OrdersService.get()
      .then(items => {
        this.items = items.map(x => {
          //x.checked = false;
          return x;
        });

        this.filteredItems = items;

        this.selectedRows.forEach(row => {
          this.$nextTick(() => this.$refs.theTable.selectRow(this.items.findIndex(item => row.DbId == item.DbId)));
        });

        if (this.filterToggle) {
          this.itemsBackup = [...this.items];
          this.items = this.selectedRows;
          this.$nextTick(() => {
            this.$refs.theTable.selectAllRows();
          });
        }

        this.recalcSums(items);

        this.isLoading = false;
        this.onWindowResize();
      })
      .finally(() => {
        if (AppState.scrollPosition[this.$route.path])
          this.$refs.theTable.$el.scrollTo({
            top: AppState.scrollPosition[this.$route.path][0],
            left: AppState.scrollPosition[this.$route.path][1]
          });
        this.displayedItemsCount = this.items.length;
      });
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  beforeRouteLeave(to, from, next) {
    AppState.scrollPosition[from.path] = [this.$refs.theTable.$el.scrollTop, this.$refs.theTable.$el.scrollLeft];
    next();
  }
};
</script>

<style>
.page-header {
  border-bottom: 1px solid #dee2e6;
}

.table-wrapper {
  border: 1px solid #dee2e6;
}

.first-col {
  left: 0;
}

.second-col {
  left: 40px;
}

.third-col {
  left: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.last-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  right: 0;
}

.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}

.table-wrapper tbody tr:hover td {
  background-color: #f0f0f0 !important;
}
/*
.table-wrapper tbody tr:hover td.sticky-col {
  background-color: #f0e9e4 !important;
}

*/

.table-striped tbody tr:nth-of-type(odd) td.sticky-col {
  background-color: #efefef !important;
}

.table-striped tbody tr:nth-of-type(even) td.sticky-col {
  background-color: #f5f5f5 !important;
}

.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}

.table-wrapper td:last-child {
  border-left: 1px solid #ced2d6;
}

.table-wrapper td:nth-last-child(2) {
  border-left: none;
  border-right: none;
}

.table.b-table > tbody > .table-active,
.table.b-table > tbody > .table-active > th,
.table.b-table > tbody > .table-active > td {
  background-color: #f5f5f5;
}

#column-selector-modal > .modal-dialog {
  position: absolute;
  top: 100px;
  right: 13px;
}

.sr-kennzeichen {
  display: inline;
  vertical-align: middle;
  border-radius: 4px;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 0;
  padding-bottom: 0;
}

.light {
  opacity: 0.4 !important;
}
</style>
